<template>
  <div class="post-preview">
    <div class="resume-title">
      <div class="line"></div>
      企业相关信息
    </div>
    <a-row class="row">
      <a-col :span="12"><b>公司名称：</b>{{ post.companyName }}</a-col>
      <a-col :span="12"
        ><b>所属产品：</b
        ><span v-for="(item, i) in post.product_name" :key="i"
          >{{ item }} &nbsp;&nbsp;</span
        ></a-col
      >
    </a-row>
    <a-row class="row">
      <a-col><b>负责HR：</b>{{ post.HR_name }}</a-col>
    </a-row>
    <div class="resume-title">
      <div class="line"></div>
      职位基本信息
    </div>
    <a-row class="row">
      <a-col :span="12"><b>职位名称：</b>{{ post.name }}</a-col>
      <a-col :span="12"
        ><b>职能类型：</b>{{ post.first_category_name }}/{{
          post.second_category_name
        }}{{
          post.third_category_name ? "/" + post.third_category_name : ""
        }}</a-col
      >
    </a-row>
    <a-row class="row">
      <a-col :span="12">
        <b>工作地点：</b>
        <span v-for="(item,i) in post.job_areas" :key="i">
          <i v-if="i != 0" style="margin-left:5em;"></i>{{ item[0] }}-{{ item[1] }}-{{ item[2] }} <br/>
        </span>
        </a-col>
      <a-col :span="12"><b>招聘人数：</b>{{ post.quantity }}人</a-col>
    </a-row>
    <a-row class="row">
      <a-col :span="12"
        ><b>薪资范围：</b>{{ post.hunter_salary_min }}-{{ post.hunter_salary_max }}万</a-col
      >
      <a-col :span="12"><b>薪资制度：</b>{{ post.salary_type }}</a-col>
    </a-row>
    <a-row class="row">
      <a-col :span="12"
        ><b>试用期薪资比例：</b>{{ post.probationary_salary_ratio }}%</a-col
      >
      <a-col :span="12"><b>职位级别：</b>{{ post.level }}</a-col>
    </a-row>
    <a-row class="row">
      <a-col class="flexDiv">
        <div>
          <b>平级情况：</b>
        </div>
        <div>
          {{ post.samelevel }}
        </div>
      </a-col>
    </a-row>
    <a-row class="row">
      <a-col class="flexDiv">
        <div>
          <b>下属团队：</b>
        </div>
        <div>
          {{ post.subordinate_team }}
        </div>
      </a-col>
    </a-row>
    <a-row class="row">
      <a-col><b>工作内容：</b>{{ post.requirements }}</a-col>
    </a-row>
    <a-row class="row">
      <a-col class="flexDiv">
        <div>
          <b>任职要求：</b>
        </div>
        <div>
          {{ post.description }}
        </div>
      </a-col>
    </a-row>
    <div class="resume-title">
      <div class="line"></div>
      职位候选人要求
    </div>
    <a-row class="row">
      <a-col :span="12"
        ><b>性别要求：</b
        >{{
          post.gender_id == "1" ? "男" : post.gender_id == "2" ? "女" : "不限"
        }}</a-col
      >
      <a-col :span="12"
        ><b>学校类型：</b
        >{{
          post.school_type == "1"
            ? "211/985"
            : post.school_type == "2"
            ? "海归"
            : "不限"
        }}</a-col
      >
    </a-row>
    <a-row class="row">
      <a-col :span="12"
        ><b>工作经验：</b
        >{{
          post.gender_id == "1"
            ? "应届毕业生"
            : post.gender_id == "2"
            ? "1年以下"
            : post.gender_id == "3"
            ? "1-2年"
            : post.gender_id == "4"
            ? "3-5年"
            : post.gender_id == "5"
            ? "6-10年"
            : post.gender_id == "6"
            ? "10年以上"
            : "不限"
        }}</a-col
      >
      <a-col :span="12"
        ><b>学历要求：</b
        >{{
          post.educationData == "1"
            ? "博士"
            : post.educationData == "2"
            ? "MBA/EMBA"
            : post.educationData == "3"
            ? "硕士"
            : post.educationData == "4"
            ? "本科"
            : post.educationData == "5"
            ? "大专"
            : post.educationData == "6"
            ? "高中/中专"
            : "不限"
        }}</a-col
      >
    </a-row>
    <!-- <a-row class="row">
        <a-col :span="12"
        ><b>年龄要求：</b
        >{{post.age_requirement}}</a-col
        >
    </a-row> -->
    <div class="resume-title">
      <div class="line"></div>
      职位备注
    </div>
    <a-row class="row">
      <a-col :span="12" class="flexDiv">
        <div>
          <b>面试流程：</b>
        </div>
        <div>
          <span v-for="(item, i) in post.interviews" :key="i"
            >{{ item }}<br
          /></span>
        </div>
      </a-col>
      <a-col :span="12" class="flexDiv">
        <div>
          <b>职位卖点：</b>
        </div>
        <div>
          <span v-for="(item, i) in post.selectedSellPointTags" :key="i"
            >{{ item
            }}<span v-if="i !== post.selectedSellPointTags.length - 1"
              >、</span
            ></span
          >
        </div>
      </a-col>
    </a-row>
    <a-row class="row">
      <a-col class="flexDiv">
        <div>
          <b>招聘原因：</b>
        </div>
        <div>
          <span v-for="(item, i) in post.selectedReasonTags" :key="i"
            >{{ item
            }}<span v-if="i !== post.selectedSellPointTags.length - 1"
              >、</span
            ></span
          >
        </div>
      </a-col>
    </a-row>
    <a-row class="row">
      <a-col class="flexDiv">
        <div>
          <b>搜寻方向：</b>
        </div>
        <div>
          <div class="flexDiv">
            <b>第一目标公司</b>
          </div>
          <div v-for="(item, i) in post.direction_companys" :key="'tag' + i">
            <div v-if="item.intention_order == '1'">
              <div class="flexDiv">
                <div style="width: 95px;text-align: right">公司名称：</div>
                <div>{{ item.company_name }}</div>
              </div>
              <div class="flexDiv">
                <div style="width: 95px;text-align: right">产品：</div>
                <div v-for="(items, i) in item.products" :key="'next' + i">
                  {{ items.name
                  }}<span v-if="i !== item.products.length - 1">、</span>
                </div>
              </div>
              <div class="flexDiv">
                <div style="width: 95px;text-align: right">备注：</div>
                <div>{{ item.notes }}</div>
              </div>
            </div>
          </div>
          <div class="flexDiv">
            <b>第二目标公司</b>
          </div>
          <div v-for="(item, i) in post.direction_companys" :key="i">
            <div v-if="item.intention_order == '2'">
              <div class="flexDiv">
                <div style="width: 95px;text-align: right">公司名称：</div>
                <div>{{ item.company_name }}</div>
              </div>
              <div class="flexDiv">
                <div style="width: 95px;text-align: right">产品：</div>
                <div v-for="(items, i) in item.products" :key="'next' + i">
                  {{ items.name
                  }}<span v-if="i !== item.products.length - 1">、</span>
                </div>
              </div>
              <div class="flexDiv">
                <div style="width: 95px;text-align: right">备注：</div>
                <div>{{ item.notes }}</div>
              </div>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
    <a-row class="row">
      <a-col class="flexDiv">
        <div>
          <b>其他要求：</b>
        </div>
        <div>
          {{ post.direction }}
        </div>
      </a-col>
    </a-row>
    <a-row class="row">
      <a-col class="flexDiv">
        <div>
          <b>职位进展：</b>
        </div>
        <div>
          {{ post.recruitment_progress }}
        </div>
      </a-col>
    </a-row>
    <a-row class="row">
      <a-col class="flexDiv">
        <div>
          <b>附件列表：</b>
        </div>
        <div v-for="(item, i) in post.attachments" :key="i">
          <span>{{ JSON.parse(item).name }}<br /></span>
        </div>
      </a-col>
    </a-row>
    <div class="resume-title">
      <div class="line"></div>
      职位评级
    </div>
    <a-row class="row">
      <a-col :span="12"
        ><b>甲方委托猎企数：</b
        >{{
          post.num_published_platforms == "1"
            ? "独家/有预付费"
            : post.num_published_platforms == "2"
            ? "小于3家"
            : post.num_published_platforms == "3"
            ? "3-5家"
            : "超过5家"
        }}</a-col
      >
      <a-col :span="12"
        ><b>面向社会已开放时长：</b
        >{{
          post.open_duration == "1"
            ? "小于一周"
            : post.open_duration == "2"
            ? "1-3周"
            : post.open_duration == "3"
            ? "3周以上"
            : "常年招聘"
        }}</a-col
      >
    </a-row>
    <a-row class="row">
      <a-col :span="12"
        ><b>职位紧急程度：</b
        >{{
          post.mergencyPosition == "1"
            ? "非常紧急"
            : post.mergencyPosition == "2"
            ? "一般紧急"
            : post.mergencyPosition == "3"
            ? "不紧急"
            : "假职位/储备简历目的"
        }}</a-col
      >
      <a-col :span="12"
        ><b>职位难度：</b
        >{{
          post.grade == "A"
            ? "A（容易）"
            : post.grade == "B"
            ? "B（一般）"
            : "C（难）"
        }}</a-col
      >
    </a-row>
    <a-row class="row">
      <a-col :span="12"
        ><b>职位类型：</b
        >{{ post.type == "PUBLIC" ? "公开职位" : "自营职位" }}</a-col
      >
    </a-row>
    <div class="resume-title">
      <div class="line"></div>
      职位负责人及服务方式
    </div>
    <a-row class="row">
      <a-col :span="12"><b>职位负责人：</b>{{ post.ie_user_id }}</a-col>
      <a-col :span="12"><b>联系电话：</b>{{ post.post_tel }}</a-col>
    </a-row>
    <a-row class="row">
      <a-col
        ><b>服务方式：</b
        >{{ post.is_reward_type == "0" ? "猎头服务" : "寻找人才线索" }}</a-col
      >
    </a-row>
    <div v-if="post.is_reward_type == '0'">
      <a-row class="row">
        <a-col :span="12"
          ><b>签约佣金：</b
          >{{ post.hunter_commission_type == "1" ? "按比例" : "按佣金"
          }}{{ post.hunter_commission_value
          }}{{ post.hunter_commission_type == "1" ? "%" : "" }}</a-col
        >
        <a-col :span="12"
          ><b>保证期：</b>{{ post.probation
          }}{{
            post.probation == "1"
              ? "1个月"
              : post.probation == "2"
              ? "2个月"
              : post.probation == "2=3"
              ? "3个月"
              : "6个月"
          }}</a-col
        >
      </a-row>
      <a-row class="row">
        <a-col class="flexDiv">
          <div>
            <b>付款细则：</b>
          </div>
          <div>
            {{ post.payment_info }}
          </div>
        </a-col>
      </a-row>
    </div>
    <div v-else>
      <a-row class="row">
        <a-col><b>悬赏金额：</b>{{ post.reward_amount }}</a-col>
      </a-row>
      <a-row class="row">
        <a-col class="flexDiv">
          <div>
            <b>悬赏政策：</b>
          </div>
          <div>
            {{ post.reward_policy }}
          </div>
        </a-col>
      </a-row>
    </div>
    <a-button
      size="large"
      type="primary"
      style="margin: auto;display: block;width: 100px"
      @click="returnPage"
      >返回</a-button
    >
  </div>
</template>

<script>
import Api from "@/api";
export default {
  name: "edit-preview",
  props: {},
  data() {
    return {
      post: {}
    };
  },
  beforeCreate() {},
  created() {},
  mounted() {
    if (this.$route.params.values) {
      let values = this.$route.params.values;
      this.post = JSON.parse(values);
    }
  },
  computed: {},
  methods: {
    returnPage() {
      if(this.$route.params.type == 'createPreview') {
        this.$router.push({
          path: '/post-edit',
        })
      } else {
        this.$router.go(-1);
      }
    },
  }
};
</script>

<style scoped lang="scss">
.post-preview {
  .resume-title {
    color: #000000;
    font-weight: bold;
    font-size: 16px;
    height: 18px;
    line-height: 18px;
    text-align: left;
    margin-bottom: 20px;
  }
  .item-title {
    width: 150px;
    box-sizing: border-box;
    padding-right: 20px;
    text-align: right;
    white-space: nowrap;
  }
  .line {
    width: 3px;
    height: 16px;
    background: #35b5fe;
    margin-right: 10px;
    float: left;
  }
  .row {
    padding-left: 40px;
    margin-bottom: 20px;
    .ant-col-12 {
      padding-right: 40px;
    }
  }
  .flexDiv {
    display: flex;
    margin-bottom: 10px;
    align-items: flex-start;
    div:last-child {
      flex: 1;
    }
  }
}
</style>
